
const {
  mm,
} = window;

export function gotoprofile(momoid) {
  mm.ui.openGoto({
    param: `[显示文本|goto_profile|${momoid}]`
  });
  // mm.invoke('ui', 'openGoto', {
  //     param: `[显示文本|goto_profile|${momoid}]`
  // });
}

export function getUrlParams(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i"); // 定义正则表达式
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
export function idleRun(func, context = null) {
  const cb = func.bind(context);
  if (window.requestIdleCallBack) {
    window.requestIdleCallBack(cb);
  } else {
    setTimeout(cb, 0);
  }
}
export function setlocalStorage(key, val) {
  const curTime = new Date().getTime();
  localStorage.setItem(key, JSON.stringify({ data: val, time: curTime }));
}
export function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  }
  return null;
}

export function debounce() {
  let timer;
  return (fn, timeout = 10) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn();
    }, timeout);
  };
}

export function throttle() {
  let prevTime;
  return (fn, gapTime) => {
    const currentTime = Date.now();
    if (!prevTime || Date.now() - prevTime > gapTime) {
      fn();
      prevTime = currentTime;
    }
  };
}

/**
 * @param {any} obj,
 */
export function isObject(obj) {
  if (typeof obj === 'object') {
    if (!obj) {
      return false;
    }
    if (Object.prototype.toString.call(obj).slice(8, -1) === 'Object') {
      return true;
    }
    return false;
  }
  return false;
}

export async function sleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}

export function compareVersion(t) {
  let v = /hnVersion\/(\d+)/g.exec(window.navigator.userAgent);
  if (!v) {
    v = 0;
  } else {
    v = Number(v[1]);
  }
  return v - t;
}
